import { memo } from 'react';
import { Package } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function CapabilityNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={Package} nodeType="capability" />;
}

export const CapabilityNode = memo(CapabilityNodeComponent);
